import Preact, { Component } from 'preact';
import { ManagePreferenceModal } from './ManagePreferenceModal';
interface Props {}
interface State {
  componentLoaded: boolean;
}

export class CookieConsent extends Component<Props> {
  state: State = { componentLoaded: false };
  componentDidMount() {
    window.addEventListener('cookiebotMoreOptions', this.showModal);
  }

  showModal = () => {
    this.setState(
      {
        componentLoaded: true,
      }
    );
  };

  render() {
    return (
      <div>
        {this.state.componentLoaded && (
          <ManagePreferenceModal openManagePref={this.state.componentLoaded} handleManagePref={(value: any) => this.setState({componentLoaded: value}) } />
        )}
      </div>
    );
  }
}
export default CookieConsent;
